import React, { SVGProps } from 'react';

export const PieChartIcon: React.FC<SVGProps<any>> = ({ fill = '#62707B' }) => {
  return (
    <svg
      fill='none'
      height='38'
      viewBox='0 0 39 38'
      width='39'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M18.8333 8.54037C17.0375 8.67627 15.3021 9.27279 13.7973 10.2783C12.0723 11.4309 10.7278 13.0691 9.93387 14.9859C9.13994 16.9026 8.93221 19.0117 9.33696 21.0465C9.7417 23.0812 10.7407 24.9503 12.2077 26.4173C13.6747 27.8843 15.5438 28.8833 17.5786 29.2881C19.6133 29.6928 21.7225 29.4851 23.6392 28.6912C25.5559 27.8972 27.1941 26.5527 28.3468 24.8277C29.3522 23.3229 29.9488 21.5875 30.0847 19.7917H18.8333L18.8333 8.54037ZM20.4167 8.54037L20.4167 18.2084H30.0847C30.0529 17.7885 29.9957 17.3695 29.913 16.9536C29.5083 14.9188 28.5092 13.0498 27.0422 11.5828C25.5752 10.1158 23.7062 9.11675 21.6714 8.712C21.2555 8.62927 20.8365 8.57214 20.4167 8.54037ZM12.9176 8.96178C14.903 7.63519 17.2372 6.92712 19.625 6.92712C20.412 6.92712 21.2009 7.00406 21.9803 7.15909C24.3222 7.62493 26.4734 8.77476 28.1618 10.4632C29.8502 12.1516 31.0001 14.3028 31.4659 16.6447C31.621 17.4241 31.6979 18.213 31.6979 19C31.6979 21.3878 30.9898 23.722 29.6633 25.7074C28.3367 27.6928 26.4511 29.2402 24.2451 30.154C22.0391 31.0677 19.6116 31.3068 17.2697 30.841C14.9278 30.3751 12.7766 29.2253 11.0881 27.5369C9.39972 25.8485 8.24988 23.6973 7.78405 21.3554C7.31821 19.0134 7.55729 16.586 8.47106 14.3799C9.38484 12.1739 10.9323 10.2884 12.9176 8.96178Z'
        fill={fill}
        fillRule='evenodd'
      />
    </svg>
  );
};
